import styled from 'styled-components';

export const ContainerEditableProducedRate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: inherit;
  background-color: var(--allie-color-light-main);
  padding: 4px;
  width: 100%;
  box-sizing: border-box;
  border-left: 1px solid var(--allie-color-primary-20);

  .allie-input {
    width: 100%;
    max-width: 140px;
    
    input {
      text-align: center !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      border: 1px solid var(--allie-color-primary-60) !important;
      
      &:focus {
        border-color: var(--allie-color-primary-80) !important;
        box-shadow: 0 0 0 2px var(--allie-color-primary-20) !important;
        outline: none !important;
      }
    }
  }
`; 